import React from 'react';
import moment from 'moment';

import { InfiniteScrollComponent } from '@playbookux/playbook-web-core';
import { Mutation } from '@apollo/client/react/components';
import { toast } from 'react-semantic-toasts';
import copy from 'copy-to-clipboard';

import {
  Body,
  CellWrapper,
  Column,
  Container,
  Header,
  HeaderColumn,
  Icon,
  IconButton,
  ReprocessButton,
  Row,
  Table,
  Text,
} from './styles';

import { SEND_CLIP_TO_PROCESS } from '../graphql';
import { videosDataPropTypes, fetchMorePropTypes, hasMorePropTypes } from './proptypes';

const VideosTable = (props) => {
  const {
    videosData,
    fetchMore,
    hasMore,
  } = props;

  const TOAST_TIME = 2500;

  async function handleProcessClip(sendClipToProcess, testSessionNoteId) {
    try {
      await sendClipToProcess({ variables: { testSessionNoteId } });

      toast({
        type: 'success',
        title: 'Success',
        description: 'Clip sent to process',
        time: TOAST_TIME,
      });
    } catch (error) {
      toast({
        type: 'error',
        title: 'Error',
        description: 'There was an error sending clip to reprocess',
        time: TOAST_TIME,
      });
    }
  }

  const handleCopyToClipboard = (content, name) => {
    copy(content);

    toast({
      description: `${name} copied to the clipboard!`,
      time: TOAST_TIME,
    });
  };

  return (
    <Container>
      <InfiniteScrollComponent
        useWindow
        onLoadMore={fetchMore}
        hasMore={hasMore}
      >
        <Table basic="very">
          <Header>
            <Row>
              <HeaderColumn>
                <Text.Bold>Test Session Note Id</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Test Session Id</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Workspace</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Project</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold>Created At</Text.Bold>
              </HeaderColumn>
              <HeaderColumn>
                <Text.Bold />
              </HeaderColumn>
            </Row>
          </Header>

          <Body>
            {videosData.map((video) => {
              const { id: testSessionNoteId, createdAt, testSession } = video;
              const { id: testSessionId, tester: { project } } = testSession;
              const { name: projectName, company: { name: companyName } } = project;

              return (
                <Row key={testSessionNoteId}>
                  <Column>
                    <CellWrapper>
                      <Text title={testSessionNoteId}>
                        {testSessionNoteId}
                      </Text>

                      <IconButton>
                        <Icon
                          name="copy"
                          onClick={() => handleCopyToClipboard(testSessionNoteId, 'Test session note Id')}
                        />
                      </IconButton>
                    </CellWrapper>
                  </Column>

                  <Column>
                    <CellWrapper>
                      <Text title={testSessionId}>
                        {testSessionId}
                      </Text>

                      <IconButton>
                        <Icon
                          name="copy"
                          onClick={() => handleCopyToClipboard(testSessionId, 'Test session Id')}
                        />
                      </IconButton>
                    </CellWrapper>
                  </Column>

                  <Column>
                    <CellWrapper>
                      <Text title={companyName}>
                        {companyName}
                      </Text>

                      <IconButton>
                        <Icon
                          name="copy"
                          onClick={() => handleCopyToClipboard(companyName, 'Worspace name')}
                        />
                      </IconButton>
                    </CellWrapper>
                  </Column>

                  <Column>
                    <CellWrapper>
                      <Text title={projectName}>
                        {projectName}
                      </Text>

                      <IconButton>
                        <Icon
                          name="copy"
                          onClick={() => handleCopyToClipboard(projectName, 'Project name')}
                        />
                      </IconButton>
                    </CellWrapper>
                  </Column>

                  <Column>
                    <Text title={moment(createdAt).format('LL')}>
                      {moment(createdAt).format('LL')}
                    </Text>
                  </Column>

                  <Column>
                    <Mutation
                      mutation={SEND_CLIP_TO_PROCESS}
                    >
                      {(sendClipToProcess, { loading: isSendingToSqs }) => (
                        <ReprocessButton
                          onClick={() => handleProcessClip(sendClipToProcess, testSessionNoteId)}
                          disabled={isSendingToSqs}
                        >
                          Reprocess
                        </ReprocessButton>
                      )}
                    </Mutation>
                  </Column>
                </Row>
              );
            })}
          </Body>
        </Table>
      </InfiniteScrollComponent>
    </Container>
  );
};

VideosTable.propTypes = {
  videosData: videosDataPropTypes.isRequired,
  fetchMore: fetchMorePropTypes.isRequired,
  hasMore: hasMorePropTypes.isRequired,
};

export default VideosTable;
